var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound container"},[_vm._m(0),_c('h2',[_vm._v("\n    "+_vm._s(_vm.$t('pageNotFoundTitle'))+"\n  ")]),_c('p',[_vm._v("\n    "+_vm._s(_vm.$t('pageNotFoundText'))+"\n    "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("\n      "+_vm._s(_vm.$t('pageNotFoundHomePage'))+"\n    ")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound-title"},[_c('h1',[_vm._v("404")])])
}]

export { render, staticRenderFns }